import {createSvgIcon} from '../create-svg-icon';

export const NavigateBeforeIcon = createSvgIcon(
  <path d="M15.61 7.41 14.2 6l-6 6 6 6 1.41-1.41L11.03 12l4.58-4.59z" />
, 'NavigateBeforeOutlined');
